var reInitGCaptcha;

function fn_layout_main() {
    var $body = $("body");

    reInitGCaptcha = function() {
        $.getScript("https://www.google.com/recaptcha/api.js?render=6LdvAQ8aAAAAAD7pOTLhsa_V-9q4IC695u6a6xBs").done(function () {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LdvAQ8aAAAAAD7pOTLhsa_V-9q4IC695u6a6xBs', {action: 'form'})
                    .then(function (token) {
                        $('#g-token').val(token);
                    });
            });
        });
    };

    if ($('form[data-recaptcha]').length) {
        reInitGCaptcha();
        setInterval(function(){reInitGCaptcha();}, 150000);
    }

    setTimeout(function(){
        $body.removeClass("preload").addClass("loaded");
        setTimeout(function () {
            $body.removeClass("loaded");
        }, 500);
    }, 250);

    $(document).on('click','[data-balikovna]', function() {
        $('[data-text-balikovna]').text('');
        $('[data-id-balikovna]').val('');
        $('[data-address-balikovna]').val('');

        $('[data-packeta-selector-branch-name]').text('');
        $('[data-deliveryMethodZasilkovna]').val('');
        $('[data-deliveryMethodZasilkovnaName]').val('');

        $.ajax({
            type: 'get',
            url: '/kosik/',
            data: {do: 'balikovna'}
        });
    });

    function iframeListener(event) {
        if (event.data.message === 'pickerResult') {
            //console.log(event.data.point);
            // Zpracovani event.data.point, pripadne event.data.phone
            $('[data-text-balikovna]').text(event.data.point.address);
            $('[data-id-balikovna]').val(event.data.point.id);
            $('[data-address-balikovna]').val(event.data.point.address);

            $("body").removeClass("no-scroll-device");
            $("#bgd").fadeOut(300);
            $(".part-dialog-balikovna").fadeOut(300);
            $("#bgd").css("pointer-events","");

            setTimeout(function () {
                $(".part-dialog-balikovna").remove();
            }, 500);
        }
    }
    window.addEventListener('message', iframeListener);

    if($('body').is('[data-dialog-open]')) {
        $.ajax({
            dataType: "json",
            data: {ajax: +new Date},
            url: $('body').filter("[data-dialog-open]").data('dialog-open')
        }).done(function(data) {

        });
    }

    $(document).on('change','#specialProduct', function() {

        var selected = $(this).prop('checked') ? 1 : 0;
        var idProduct = parseInt($(this).val());

        $.ajax({
            type: 'post',
            data: {do: 'changeSpecialProduct', selected: selected, idProduct: idProduct}
        });

    });

    $(document).on('click','[data-go-back]',function() {
        $('body').html('');
        history.go(-1);
        return false;
    });

    $(document).on('click','[data-next-step]', function() {

        $('button.next-step-button').trigger('click');

    });

    $("[data-shipping-info]").on("click",function(e){
        e.preventDefault();
        $(this).toggleClass("active").closest(".cols").find(".status").fadeToggle(300);
    });

    $('[name="delivery"]').on('change', function(){
        var $elm = $(this);

        $elm.closest('fieldset').find('.status').hide();

        if($elm.prop('checked')) {
            $elm.closest(".cols").find(".status").fadeIn();
        }
    });

    var headroom = new Headroom(document.querySelector("#main-header"), {
        "offset": 30,
        "tolerance": 0,
        "classes": {
            "initial": "animated",
            "pinned": "slideDown",
            "unpinned": "slideUp"
        }
    });
    headroom.init();

    if ($("[data-custom-select]").length) {
        $("[data-custom-select]").each(function(){
            if ($(this).attr("data-custom-select") == "color") {
                function formatState (state) {
                    if (!state.id) { return state.text; }
                    var $state = $(
                        '<span class="color-item"><i class="color" style="background-color: '+$(state.element).data("color")+'"></i> <i>' + state.text + '</i></span>'
                    );
                    return $state;
                }
                $(this).select2({
                    templateResult: formatState,
                    templateSelection: formatState,
                    minimumResultsForSearch: Infinity
                });
            } else {
                $(this).select2({
                    minimumResultsForSearch: Infinity
                });
            }
        });
    }
}
